<template>
    <ui-DeviceThermostat
        :name="device.name"
        :subName="subName"
        :min="status.getTempMin() | toNumber"
        :max="status.getTempMax() | toNumber"
        :real="status.getTemp() | toNumber"
        :order="status.getOrder() | toNumber"
        :status="status.isOn()"
        :standby="status.isStanby()"
        :modeHeat="status.isModeHeat()"
        :outService="status.isOutService()"
        __:disabled="device.disabled"
        @update:status="togglePowerDevice"
        @click="$emit('click', device)"
    >
        <template v-slot:properties>
            <ui-Ico v-if="status.allowAC()" :disabled="!status.isModeAC()" valueIco="ac"></ui-Ico>
            <ui-Ico v-if="status.allowFloor()" :disabled="!status.isModeFloor()" valueIco="radiatingFloor"></ui-Ico>
            <ui-Ico v-if="status.allowFan()" :disabled="!status.hasFanMode()" valueIco="ventilation"></ui-Ico>
        </template>
    </ui-DeviceThermostat>
</template>

<script>
    import { DeviceMixin } from '../mixins/DeviceMixin';

    export default {
        name: 'Device',
        mixins: [DeviceMixin],
        props: {
            //device: Object,
            //status: Object,
            //outService: Boolean,
            subName: String,
        },
    };
</script>
